import { Icon } from '@/components';
import { ButtonSize } from '@/components/button/types';
import { IconName } from '@/components/icons/types';
import { cn } from '@/utils/styles';
import { ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

export type InterestRadioButtonProps = {
  readonly id: string;
  readonly value: string;
  readonly icon?: string;
  readonly size?: ButtonSize;
  readonly children: ReactNode;
  readonly isSelected?: boolean;
  readonly className?: string;
  readonly registration?: Partial<UseFormRegisterReturn>;
  readonly flag?: string;
};

export function InterestRadioButton({
  id,
  value,
  icon,
  size,
  children,
  isSelected,
  className,
  registration,
  flag
}: InterestRadioButtonProps) {
  return (
    <label
      htmlFor={id}
      className={`flex cursor-pointer items-center justify-center gap-2 rounded-lg border px-4 py-2 text-sm font-semibold transition-all duration-200 hover:scale-105 hover:shadow-md active:scale-95 md:text-base ${className}`}
      style={{
        borderColor: '#279D59',
        backgroundColor: isSelected ? '#279D59' : 'white',
        color: isSelected ? 'white' : '#279D59',
      }}
    >
      <input type="checkbox" id={id} value={value} className="sr-only" {...registration} />
      {icon ? (
        <span className="font-heading flex items-center justify-center gap-x-1 text-base">
          <Icon name={icon as IconName} className={cn('text-inherit', size === 'sm' ? 'h-5 w-5' : 'h-6 w-6')} />

          {children}
        </span>
      ) : (
        <span className="font-heading flex items-center justify-center gap-x-1 text-base">
          {flag ? flag : ''}
          {children}
        </span>
      )}
    </label>
  );
}
